import { render, staticRenderFns } from "./publicCouponDialog.vue?vue&type=template&id=38c3dbfc&scoped=true&"
import script from "./publicCouponDialog.vue?vue&type=script&lang=js&"
export * from "./publicCouponDialog.vue?vue&type=script&lang=js&"
import style0 from "./publicCouponDialog.vue?vue&type=style&index=0&id=38c3dbfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c3dbfc",
  null
  
)

export default component.exports